import type { OnboardingStep, ProgressSegment, SectionId } from "../domain/types";

export type OnboardingRoute = {
  section: SectionId;
  mapOpen: boolean;
  progressSegment: ProgressSegment;
  arenaView: "catalog" | "penalty";
  scrollTarget: string | null;
};

const ONBOARDING_ROUTES: Record<OnboardingStep, OnboardingRoute> = {
  welcome: {
    section: "core",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  tap: {
    section: "core",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  map: {
    section: "core",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  workshop: {
    section: "core",
    mapOpen: true,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  upgrade: {
    section: "development",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: ".machine-module--mechanical",
  },
  passive: {
    section: "development",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  trophy: {
    section: "core",
    mapOpen: true,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  "trophy-overview": {
    section: "progress",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  season: {
    section: "progress",
    mapOpen: false,
    progressSegment: "today",
    arenaView: "catalog",
    scrollTarget: null,
  },
  "season-overview": {
    section: "progress",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: ".trophy-season-chronicle",
  },
  "season-return": {
    section: "progress",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: ".trophy-season-chronicle",
  },
  club: {
    section: "core",
    mapOpen: true,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: null,
  },
  "club-overview": {
    section: "friends",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: null,
  },
  "club-link": {
    section: "friends",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: ".makers-club-gate",
  },
  "club-return": {
    section: "friends",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: ".makers-club-gate",
  },
  arena: {
    section: "core",
    mapOpen: true,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: null,
  },
  "arena-overview": {
    section: "games",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: null,
  },
  "arena-game": {
    section: "games",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: ".arena-game-card.is-playable",
  },
  "arena-return": {
    section: "core",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: null,
  },
  complete: {
    section: "core",
    mapOpen: false,
    progressSegment: "season",
    arenaView: "catalog",
    scrollTarget: null,
  },
};

export function onboardingRouteForStep(step: OnboardingStep): OnboardingRoute {
  return ONBOARDING_ROUTES[step];
}
